import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { useEffect, useImperativeHandle, useState } from 'react';
import { DialogTitle } from '@mui/material';
import LoadingEvent from './Skeleton/LoadingEvent';

function ConfirmationPopUp({ reference }) {
  const defaultOptions = {
    Icon: null,
    message: null,
    positiveButtonText: 'Yes',
    positiveButtonIcon: null,
    negativeButtonIcon: null,
    negativeButtonText: 'No',
    loadingMessage: 'Processing...',
    width: 360,
    title: null,
    onChange: () => undefined,
  };

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  useImperativeHandle(reference, () => ({
    setOpen(value) {
      setOpen(value);
      if (!value) {
        setButtonsDisabled(false);
      }
    },
    setLoading(value) {
      setLoading(value);
    },
    init(popupOptions) {
      setOptions(popupOptions);
    },
  }));

  useEffect(() => {
    if (!open) {
      setLoading(false);
      setOptions(defaultOptions);
    }
  }, [open]);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: options?.width,
        bgcolor: 'background.paper',
      }}>
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        open={open}>
        {options?.title && !loading && (
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {options?.Icon || null}
            {options?.title}
          </DialogTitle>
        )}
        {loading ? (
          <DialogContent>
            <LoadingEvent>{options?.loadingMessage}</LoadingEvent>
          </DialogContent>
        ) : (
          <DialogContent sx={{ mt: 1 }}>{options?.message}</DialogContent>
        )}
        {!loading ? (
          <DialogActions
            style={{
              justifyContent: 'center',
              marginTop: '10px',
              marginBottom: '10px',
            }}>
            {options?.positiveButtonText && (
              <Button
                {...(options?.positiveButtonIcon && {
                  startIcon: options?.positiveButtonIcon,
                })}
                disabled={buttonsDisabled}
                variant="contained"
                onClick={async () => {
                  setButtonsDisabled(true);
                  await options?.onChange(true);
                  setButtonsDisabled(false);
                }}>
                {options?.positiveButtonText}
              </Button>
            )}
            {options?.negativeButtonText && (
              <Button
                {...(options?.negativeButtonIcon && {
                  startIcon: options?.negativeButtonIcon,
                })}
                disabled={buttonsDisabled}
                variant="outlined"
                style={{ marginLeft: '20px' }}
                onClick={async () => {
                  setButtonsDisabled(true);
                  await options?.onChange(false);
                  setButtonsDisabled(false);
                }}>
                {options?.negativeButtonText}
              </Button>
            )}
          </DialogActions>
        ) : null}
      </Dialog>
    </Box>
  );
}

export default ConfirmationPopUp;
